import { render, staticRenderFns } from "./layActiveTable.vue?vue&type=template&id=4677bb64"
import script from "./layActiveTable.vue?vue&type=script&lang=js"
export * from "./layActiveTable.vue?vue&type=script&lang=js"
import style0 from "./layActiveTable.vue?vue&type=style&index=0&id=4677bb64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports